
.DayColumnAddEvent {
    display: block;
    position: absolute;
    inset: 0;

    &.isDragover {
        background-color: var(--soniq-t--global--background--color--status--info--default);
    }
}


.DayColumnAddEvent__placeholder {
    width: 90%;
    display: block;
    background: var(--soniq-t--global--background--color--accent--active--default);
    border: solid 1px var(--soniq-t--global--border--color--accent--active--default);
    pointer-events: none;
    position: absolute;
    border-radius: 5px;
}

/* Where a dragged event will land if dropped */
.DayColumnAddEvent__dropLine {
    position: absolute;
    inset-inline: 0;
    border-top: solid 2px var(--soniq-t--global--border--color--accent--today--default);
    pointer-events: none;
    z-index: 1;
    font-size: .7rem;
    line-height: 1;
    padding: 2px 3px;
    color: var(--soniq-t--global--text--color--primary--default);
}
